import { BaseTable } from './BaseTable'
import { usePriceGetAgDetailsContext } from './PriceGetAgDetailsContext'

export const OtherCostsTable = () => {
  const { getAgPriceDetails, t, getAgPriceType, tax } =
    usePriceGetAgDetailsContext()

  return (
    <BaseTable
      rows={[
        {
          label: t(
            'getag_details_table.groups.other_fees.fees.concession',
            'Konzessions­abgabe'
          ),
          isEmpty:
            !getAgPriceDetails.breakdown.variable?.['concession']?.amount,
          amountDecimal:
            getAgPriceDetails.breakdown.variable?.['concession']
              ?.amount_decimal,
          unitAmountDecimal:
            getAgPriceDetails.breakdown.variable?.['concession']
              ?.unit_amount_decimal,
          tax
        },
        ...(getAgPriceType === 'power'
          ? [
              {
                label: t(
                  'getag_details_table.groups.other_fees.fees.chp',
                  'KWKG-Umlage'
                ),
                isEmpty: !getAgPriceDetails.breakdown.variable?.['chp']?.amount,
                amountDecimal:
                  getAgPriceDetails.breakdown.variable?.['chp']?.amount_decimal,
                unitAmountDecimal:
                  getAgPriceDetails.breakdown.variable?.['chp']
                    ?.unit_amount_decimal,
                tax
              },
              {
                label: t(
                  'getag_details_table.groups.other_fees.fees.extra_charge',
                  '§19 StromNEV Umlage'
                ),
                isEmpty:
                  !getAgPriceDetails.breakdown.variable?.['extra_charge']
                    ?.amount,
                amountDecimal:
                  getAgPriceDetails.breakdown.variable?.['extra_charge']
                    ?.amount_decimal,
                unitAmountDecimal:
                  getAgPriceDetails.breakdown.variable?.['extra_charge']
                    ?.unit_amount_decimal,
                tax
              },
              {
                label: t(
                  'getag_details_table.groups.other_fees.fees.offshore_liability_fee',
                  'Offshore-Umlage'
                ),
                isEmpty:
                  !getAgPriceDetails.breakdown.variable?.[
                    'offshore_liability_fee'
                  ]?.amount,
                amountDecimal:
                  getAgPriceDetails.breakdown.variable?.[
                    'offshore_liability_fee'
                  ]?.amount_decimal,
                unitAmountDecimal:
                  getAgPriceDetails.breakdown.variable?.[
                    'offshore_liability_fee'
                  ]?.unit_amount_decimal,
                tax
              },
              {
                label: t(
                  'getag_details_table.groups.other_fees.fees.power_tax',
                  'Stromsteuer'
                ),
                isEmpty:
                  !getAgPriceDetails.breakdown.variable?.['power_tax']?.amount,
                amountDecimal:
                  getAgPriceDetails.breakdown.variable?.['power_tax']
                    ?.amount_decimal,
                unitAmountDecimal:
                  getAgPriceDetails.breakdown.variable?.['power_tax']
                    ?.unit_amount_decimal,
                tax
              }
            ]
          : [
              {
                label: t(
                  'getag_details_table.groups.other_fees.fees.neutrality_charge',
                  'Bilanzierungsumlage'
                ),
                isEmpty:
                  !getAgPriceDetails.breakdown.variable?.['neutrality_charge']
                    ?.amount,
                amountDecimal:
                  getAgPriceDetails.breakdown.variable?.['neutrality_charge']
                    ?.amount_decimal,
                unitAmountDecimal:
                  getAgPriceDetails.breakdown.variable?.['neutrality_charge']
                    ?.unit_amount_decimal
              },
              {
                label: t(
                  'getag_details_table.groups.other_fees.fees.gas_storage',
                  'Gasspeicherumlage'
                ),
                isEmpty:
                  !getAgPriceDetails.breakdown.variable?.['gas_storage']
                    ?.amount,
                amountDecimal:
                  getAgPriceDetails.breakdown.variable?.['gas_storage']
                    ?.amount_decimal,
                unitAmountDecimal:
                  getAgPriceDetails.breakdown.variable?.['gas_storage']
                    ?.unit_amount_decimal,
                tax
              },
              {
                label: t(
                  'getag_details_table.groups.other_fees.fees.gas_conversion_charge',
                  'Konvertierungsumlage'
                ),
                isEmpty:
                  !getAgPriceDetails.breakdown.variable?.[
                    'gas_conversion_charge'
                  ]?.amount,
                amountDecimal:
                  getAgPriceDetails.breakdown.variable?.[
                    'gas_conversion_charge'
                  ]?.amount_decimal,
                unitAmountDecimal:
                  getAgPriceDetails.breakdown.variable?.[
                    'gas_conversion_charge'
                  ]?.unit_amount_decimal,
                tax
              },
              {
                label: t(
                  'getag_details_table.groups.other_fees.fees.gas_tax',
                  'Erdgassteuer'
                ),
                isEmpty:
                  !getAgPriceDetails.breakdown.variable?.['gas_tax']?.amount,
                amountDecimal:
                  getAgPriceDetails.breakdown.variable?.['gas_tax']
                    ?.amount_decimal,
                unitAmountDecimal:
                  getAgPriceDetails.breakdown.variable?.['gas_tax']
                    ?.unit_amount_decimal,
                tax
              },
              {
                label: t(
                  'getag_details_table.groups.other_fees.fees.co2',
                  'CO2-Preis'
                ),
                isEmpty: !getAgPriceDetails.breakdown.variable?.['co2']?.amount,
                amountDecimal:
                  getAgPriceDetails.breakdown.variable?.['co2']?.amount_decimal,
                unitAmountDecimal:
                  getAgPriceDetails.breakdown.variable?.['co2']
                    ?.unit_amount_decimal,
                tax
              }
            ])
      ]}
      title={t(
        'getag_details_table.groups.other_fees.title',
        'Abgaben, Umlagen & Steuern'
      )}
    />
  )
}
